// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vXJQ","index":"styles_index__2NqZ2"};